import { message } from 'antd';
import { createMatchSelector, push } from 'connected-react-router';
import { markNotificationAsRead, updateItemCart } from 'containers/MainLayout/actions';
import { call, fork, put, select, take } from 'redux-saga/effects';
import translations from 'translations';
import { bulkReorder, downloadDeliveryNoteApi, getFulfillmentNote, submitFeedback } from 'utils/apollo';
import { handleDownloadPdfFromBase64 } from 'utils/downloadFileFromBase64';
import { EventName, sendGA4Event } from 'utils/triggerGA4Event';
import ordersMessages from '../../containers/OrdersPage/messages';
import { bulkReorder as bulkReorderActions, fulfillmentNote as fulfillmentNoteActions, ratingAction } from './actions';
import ActionTypes from './constants';

function* initData() {
  yield put(fulfillmentNoteActions.request());
  const route = yield select(createMatchSelector('/phieu-giao/:id'));

  const messageId = new URLSearchParams(window.location.search).get('messageId');
  if (messageId) {
    yield put(markNotificationAsRead({ messageId: messageId }));
  }

  const response = yield call(getFulfillmentNote, {
    id: route.params.id,
  });
  if (response.errors) {
    yield put(fulfillmentNoteActions.failure(response.errors));
  } else {
    yield put(fulfillmentNoteActions.success(response));
  }
}

function* bulkReOrderFlow() {
  while (true) {
    const { payload } = yield take(ActionTypes.BULK_REORDER);
    yield put(bulkReorderActions.request());

    const response = yield call(bulkReorder, { input: { ...payload } });
    if (!response.errors) {
      yield put(bulkReorderActions.success(response));
      yield put(updateItemCart.success(response.cart));
      yield put(push('/checkout'));
    } else {
      yield put(bulkReorderActions.failure(response.errors));
    }
  }
}

function* ratingFlow() {
  while (true) {
    const { payload } = yield take(ActionTypes.RATE);
    yield put(ratingAction.request());
    const response = yield call(submitFeedback, { input: { ...payload } });

    if (!response.errors) {
      yield put(ratingAction.success({ feedback: response.feedback, objectId: payload.objectId }));
      if (!payload?.dismissed) {
        message.success(translations(ordersMessages.submitFeedbackSuccessfully));
      }
    } else {
      yield put(ratingAction.failure(response.errors));
      sendGA4Event(EventName.SUBMIT_RATING_ERROR, {
        ffm_id: payload.objectId,
      });
      message.error(response.errors[0].message);
    }
  }
}
function* downloadDeliveryNoteFlow() {
  while (true) {
    const { payload } = yield take(ActionTypes.DOWNLOAD_DELIVERY_NOTE);
    const { fulfillmentNoteId, cb } = payload;

    const response = yield call(downloadDeliveryNoteApi, {
      input: {
        ffmNoteId: fulfillmentNoteId,
      },
    });

    if (!response.errors) {
      message.success(translations(ordersMessages.downloadDeliveryNoteSuccess));
      handleDownloadPdfFromBase64({
        base64String: response.data,
        fileName: `delivery_note_${fulfillmentNoteId}.pdf`,
        openPreviewFile: true,
      });
    } else {
      message.error(translations(ordersMessages.downloadDeliveryNoteFailed));
    }
    if (cb) {
      cb();
    }
  }
}

export default function* fulfillmentNoteDetailPageSaga() {
  yield fork(initData);
  yield fork(bulkReOrderFlow);
  yield fork(ratingFlow);
  yield fork(downloadDeliveryNoteFlow);
}
